import { render, staticRenderFns } from "./AgreementsSummary.vue?vue&type=template&id=1c0e13a0&"
import script from "./AgreementsSummary.vue?vue&type=script&lang=js&"
export * from "./AgreementsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports